import type { FeatureGroupBy } from './types';

export const FEATURE_RANGE_OPTIONS = [
  { days: 7, label: '7 days' },
  { days: 30, label: '30 days' },
  { days: 90, label: '90 days' },
] as const;

export const DEFAULT_RANGE_DAYS = 30;
export const DEFAULT_GROUP_BY: FeatureGroupBy = 'feature';

/** Server groups the tail into this code when there are more slices than the configured maximum. */
export const OTHER_SLICE_CODE = 'other';

/** Distinct hues with enough contrast on both light and dark cards; the legend always carries text. */
export const FEATURE_SLICE_COLORS = [
  '#3B82F6',
  '#10B981',
  '#F59E0B',
  '#EF4444',
  '#8B5CF6',
  '#EC4899',
  '#14B8A6',
  '#F97316',
  '#6366F1',
] as const;
export const OTHER_SLICE_COLOR = '#94A3B8';
